import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormInputComponent } from '../../../components/ui-components/forms/form-input/form-input.component';
import { CardButtonComponent } from '../../../components/ui-components/buttons/card-button/card-button.component';
import { CardButtonBackground, CardButtonSize } from '../../../components/ui-components/buttons/card-button/card-button.model';
import { FormInputType } from '../../../components/ui-components/forms/form-input/form-input.model';
import { TenderType } from 'src/app/services/model/tender-type.enum';
import { DropdownComponent } from '../../../components/ui-components/dropdown/dropdown.component';
import { DropdownOption } from 'src/app/components/ui-components/dropdown/dropdown.model';
import { PaymentTypesService } from 'src/app/services/payment-types.service';
import { SafeUrlPipe } from '@dert-pipes';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-valuables-report',
  templateUrl: './valuables-report.component.html',
  styleUrls: ['./valuables-report.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    FormInputComponent,
    CardButtonComponent,
    DropdownComponent,
    SafeUrlPipe,
  ],
})
export class ValuablesReportComponent implements OnInit {
  reportForm = new FormGroup({
    dateFrom: new FormControl(''),
    dateTo: new FormControl(''),
    valuableType: new FormControl(''),
    bnrVs: new FormControl(''),
    amountFrom: new FormControl(''),
    amountTo: new FormControl(''),
  });

  CardButtonSize = CardButtonSize;
  CardButtonBackground = CardButtonBackground;
  FormInputType = FormInputType;
  
  valuableTypes: DropdownOption[] = [];
  private paymentTypesService = inject(PaymentTypesService);
  private _sharedService = inject(SharedService);

  public reportUrl: string | null = "https://test-api-ng.dertouristik.cz/Reports/report/NG/CS/transaction_CZ_a5?rs:embed=true&HeaderID=63365";

  async ngOnInit() {
    const paymentTypes = await this._sharedService.getPaymentTypes();
    this.valuableTypes = paymentTypes
        .filter(pt => [TenderType.Cash, TenderType.Voucher, TenderType.Cheque].includes(pt.TenderType))
        .map(pt => ({ value: pt.TenderType, label: pt.Description }));
  }

  search() {
    console.log(this.reportForm.value);
  }

  downloadReportPdf() {
    const url = this.getReportPdfUrl();
    if (url) {
      window.open(url, '_blank');
    }
  }

  private getReportPdfUrl(): string | null {
    if (!this.reportUrl) {
      return null;
    }
    try {
      const parsedUrl = new URL(this.reportUrl);
      parsedUrl.searchParams.set('rs:Format', 'PDF');
      parsedUrl.searchParams.set('rs:Command', 'Render');
      parsedUrl.searchParams.delete('rs:embed');
      return parsedUrl.toString();
    } catch (error) {
      const delimiter = this.reportUrl.includes('?') ? '&' : '?';
      return `${this.reportUrl}${delimiter}rs:Command=Render&rs:Format=PDF`;
    }
  }
}
